import { render, staticRenderFns } from "./EnclosureDialog.vue?vue&type=template&id=36e2b3aa&scoped=true"
import script from "./EnclosureDialog.vue?vue&type=script&lang=ts"
export * from "./EnclosureDialog.vue?vue&type=script&lang=ts"
import style0 from "./EnclosureDialog.vue?vue&type=style&index=0&id=36e2b3aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2b3aa",
  null
  
)

export default component.exports